import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

const root = document.getElementById('root')
if (!root) {
  document.body.innerHTML = '<h1 style="color:red">Error: #root not found</h1>'
} else {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
  // Hide loading message
  const loading = document.getElementById('loading')
  if (loading) loading.style.display = 'none'
}
